export function getLatLngFromAddress(place_id) {
  const API_PLACES_URL = `${process.env.NEXT_PUBLIC_CYCLONE_API_URL}/google/places/details/${place_id}`;

  return fetch(API_PLACES_URL)
    .then((res) => res.json())
    .then((data) => {
      // Handle new API structure
      if (data.location) {
        const { latitude, longitude } = data.location;
        return { lat: latitude, lng: longitude };
      }
      // Fallback to old structure
      if (data.geometry && data.geometry.location) {
        const { lat, lng } = data.geometry.location;
        return { lat, lng };
      }
      // Return null if no location found
      return { lat: null, lng: null };
    })
    .catch((error) => {
      console.error('Error fetching lat/lng from address', error);
      return { lat: null, lng: null };
    });
}

export const defaultUbication = {
  lat: -34.5928577,
  long: -58.4387185,
  distance: 11
};
